<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 15:33:08
 * @LastEditTime: 2021-01-20 11:21:13
 * @LastEditors: daikeyi
 -->
<template>
<div id='page_Container'>
    <!--导航栏-->
    <div class="page">
        <div id='main-container' class="homenew">
            <div class="flex home-header">
                <div class="company-wrapper" @click="choiceCompany">
                    <img class="location_icon" src="../assets/img/home/companyAddress.png" alt="">
                    <span class="companyName">{{subcompanyName}}</span>
                    <div class="sanjiao_down"></div>
                </div>
                <commonSearch :searchType="searchType" :type='styleType' :searchMassage="searchMassage" @goSearch="goSearch"></commonSearch>

            </div>
            <!-- 首页轮播 -->
            <div class='lunbo' v-show='initShow'>

                <van-swipe :autoplay='3000' class="vanSwipe">
                    <van-swipe-item v-for='(image, index) in titleIndex' :key='index'>
                        <img :src='image.commont' style='width:100%;' @click="goactdetail(image)" class="needsclick">
                    </van-swipe-item>
                </van-swipe>
            </div>
            <!-- 首页功能模块 -->
            <div class='home-menu-zone'>
                <menu-panel :menus='menus' @itemClicked='goactdetail' />
            </div>
            <!--通知公告-->
            <!-- <div class='notice'  v-if="noticesShow">
                    <span class='notice-label'>
                        <img src='../assets/img/home/noticepng.png' alt=''>
                        <span class='vertical'></span>
                    </span>
                    <div class='notice-warp'>
                        <vue-seamless-scroll :data='notices' :class-option='noticesOption'>
                            <ul class='notice-item'>
                                <li class="noticeli" v-for='item in notices' :key='item.id' @click="goactdetail(item)">
                                    {{item.adName}}
                                </li>
                            </ul>
                        </vue-seamless-scroll>
                    </div>
                </div> -->
            <!-- 首页小轮播 -->
            <!-- <div class='ad'>
                    <ul>
                        <li  v-for='(image, index) in roundIndex' :key='index'>
                            <img :src='image.commont' @click="goactdetail(image)">
                        </li>
                    </ul>
                </div> -->
            <!-- 热门推荐 -->
            <!-- <div class='home-recommend'>
                    <van-tabs v-model='active' swipeable>
                        <van-tab v-for='index in tagIndex' :title='index.tagName' :key='index.id' class="clearfix">
                            <div class='goods' v-for='(good, index) in index.prodcutList' :key='index.id' @click="godetail(good)">
                                <div class="goodsshell">
                                    <img :src="good.productImages.split(',')[0]" alt=''>
                                    <div class="title">
                                        <div class='goodstitle'>{{good.name}}</div>
                                    </div>
                                    <p class='goodsprice'>¥{{commonJs.priceTofixed(good.minPrice)}}<span v-if="good.marketPrice">¥{{commonJs.priceTofixed(good.marketPrice)}}</span></p>
                                </div>
                            </div>
                        </van-tab>
                    </van-tabs>
                </div> -->
            <!-- 小轮播改版 -->
            <div :class="{newSwiper: true, bcf: newSwiper}">
                <van-row gutter="10">
                    <van-col class="commonCol" span="12" v-for='(image, index) in roundIndex' :key='index'>
                        <img :src="image.commont" alt="" @click="goactdetail(image)">
                    </van-col>
                    <!-- <van-col class="commonCol" span="12" >
                        <img src="../assets/img/common/Shape@2x.png" alt="" @click="esvOpenPage({name: 'OPActivityPage',query:{activityImgId:12}})">
                    </van-col> -->
                    <!-- <van-col class="commonCol" span="12" >
                        <img src="../assets/img/common/Shape@2x.png" alt="" @click="esvOpenPage({name: 'OPGroupDetail',query:{id:45}})">
                    </van-col> -->
                </van-row>
            </div>
            <!-- 推荐改版 -->
            <div class="recommendNew" v-for='(item, index) in tagIndex' :key='item.id'>
                <div class="recommendContent" v-if="item.prodcutList.length == 2">
                    <div class="recommendTop"><img :src="item.tagImage" @click="tagFun(item.id, index)" alt=""></div>
                    <div class="recommendBottom">
                        <ul>
                            <li v-for='(good, index) in item.prodcutList' :key='index' @click="godetail(good)">
                                <div class="recommendImg"><img :src="good.image" alt=""></div>
                                <div class="recommendDescribe">{{good.name}}</div>
                                <div class='goodIntegral'>
                                    <integralDeduction v-if='good.maxDeductionAmount' :goodData='good'></integralDeduction>
                                </div>
                                <div class="goodDescribe">
                                    <div class="describeLeft">￥{{good.minPrice}}</div>
                                    <div class="describeRight">{{good.salesNum}}人已买</div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class='bottomText' v-show='initShow'>
                <div class="copyright">© 2019-{{ new Date().getFullYear() }} <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备17054838号</a></div>
                <span>易联云商城定制版-易联云提供技术支持</span>
            </div>
            <!-- <div class="holdplace"></div> -->
            <div class='call' @click='callFn' v-show='initShow'>
                <div>
                    <img :src="phoneImg" alt="" class='img'>
                </div>
                <div>
                    <span class='spanText'>客服</span>
                </div>
            </div>
        </div>
        <div>
            <van-popup v-model="callshow" position="bottom" class='classBottom'>
                <callPhone @on-cancel="closeCall" :iphoneNumber="merchantInfo.merchantPhone"></callPhone>
            </van-popup>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex';
import menuPanel from '@/components/common/menuPanel';
// import vueSeamlessScroll from 'vue-seamless-scroll';
import mockDatanew from '@/mock/datanew';
import config from '@/constant/config';
import commonSearch from '@/components/common/commonSearch';
import integralDeduction from '@/components/common/integralDeduction';
import {
    toastLoading,
    clearToastLoading
} from '@/utils/base/utils';
// import {
//     Toast
// } from 'vant';
// import * as types from '@/store/modules/types';

export default {
    components: {
        menuPanel,
        // vueSeamlessScroll,
        commonSearch,
        integralDeduction,
        callPhone: () => import('@/components/base/callPhone')
    },
    name: 'homenew',
    computed: {
        noticesOption() {
            return config.noticesOption;
        },
        ...mapGetters([
            'cTabIndex', 'direction', 'searchInfo', 'loadWXConfig', 'merchantInfo'
        ])
    },
    data() {
        return {
            timer: '',
            callshow: false,
            phoneImg: require('../assets/img/home/dianhua.png'),
            phonehImg: require('../assets/img/home/dianhuah.png'),
            newSwiper: false,
            initShow: false,
            styleType: '3',
            searchMassage: '请输入商品名称',
            searchType: '1',
            active: 0,
            noticesShow: false,
            notices: [],
            roundIndex: [],
            titleIndex: [],
            menus: [],
            tagIndex: [],
            diyIndex: '',
            recommend: mockDatanew.recommend,
            goods: mockDatanew.goods,
            isLoading: false,
            iphoneNumber: '',
            subcompanyName: ''
        };
    },
    props: {},
    esvReady: function () {},
    esvShow: function () {
        if (process.env.NODE_ENV === 'development') {
            this.setWxAuthenticate(1);
            this.setMerchantInfo().then((data) => {
                document.title = data.wechantTitle;
            });
        }
        if (this.merchantInfo.wechantTitle) {
            document.title = this.merchantInfo.wechantTitle;
        }
        this.ESVStorage.getSavedValue('shortCode', (data) => {
            this.shortCode = data;
            setTimeout(() => {
                this.loading = toastLoading();
                console.log('准备调用接口');

                Promise.all([this.init(), this.querySubcompanyList()]).then(data => {
                    clearToastLoading(this.loading);
                }).catch(data => {
                    clearToastLoading(this.loading);
                });
            }, 10);
        });
        this.imgShow = false;
        this.ESVStorage.putSavedValue('cTabIndex', 0);
        this.ESVStorage.removeSavedValue('current');
    },
    methods: {
        ...mapActions(['setSearchInfo', 'setWxAuthenticate', 'setMerchantInfo']),
        querySubcompanyList() {
            const ths = this;
            return new Promise((resolve, reject) => {
                ths.$doRequest({
                    url: '/merchant/querySubcompanyList',
                    params: {

                    },
                    before: function () {
                        // ths.loading = toastLoading();
                    },
                    complete: function () {
                        clearToastLoading(ths.loading);
                    }
                }, (data) => {
                    data.result.forEach(item => {
                        if (item.shortCode === ths.shortCode) {
                            ths.subcompanyName = item.subcompanyName;
                        }
                    });
                    if (!ths.subcompanyName) {
                        ths.subcompanyName = data.result[0].subcompanyName;
                    }
                    resolve(data);
                },
                (data) => {
                    reject(data);
                }
                // function (data) {
                //
                // }
                );
            });
        },
        goSearch() {
            this.setSearchInfo({
                searchType: this.searchType,
                productName: this.searchMassage === '请输入商品名称' ? '' : this.searchMassage
            });
            // this.$store.commit(types.APP_SEARCH_FLAG, '');
            this.esvOpenPage({
                name: 'OPSearch'
            });
        },
        // 选择子公司
        choiceCompany() {
            this.esvOpenPage({
                name: 'OPChoiceCompany',
                params: {
                    subcompanyName: this.subcompanyName
                }
            });
        },
        tagFun(id, index) {
            this.esvOpenPage({
                name: 'OPTagList',
                query: {
                    id: id,
                    index: index
                }
            });
        },
        goSys() {
            this.esvOpenPage('OPSysMaintenance');
        },
        // 初始化
        init() {
            window.esvcpInit = (new Date()).getTime();
            const ths = this;
            const params = {};
            return new Promise((resolve, reject) => {
                window.queryIndexDetailTime = (new Date()).getTime();
                console.time('queryIndexDetail');
                ths.$doRequest({
                    url: '/index/queryIndexDetail',
                    params: params,
                    before: function () {
                        ths.loading = toastLoading();
                    },
                    complete: function () {
                    // clearToastLoading(ths.loading);
                    // afterFn && afterFn();
                    }
                },
                (data) => {
                    console.timeEnd('queryIndexDetail');
                    console.timeEnd('setTimeout');
                    ths.initShow = true;
                    ths.menus = data.result.itemIndex;
                    ths.notices = data.result.adIndex;
                    if (data.result.adIndex.length > 0) {
                        ths.noticesShow = true;
                    }
                    ths.roundIndex = data.result.roundIndex;
                    ths.titleIndex = data.result.titleIndex;
                    ths.tagIndex = data.result.tagIndex;
                    ths.ESVStorage.putSavedValue('tagIndex', ths.tagIndex);
                    ths.$nextTick(function () {
                        ths.customize();
                    });
                    ths.newSwiper = true;
                    resolve(data);
                },
                (data) => {
                    reject(data);
                }
                );
            });
        },
        customize: function () {
            if (document.querySelectorAll('.customize')[0] !== undefined) {
                const customizeOldImgWidth = document.querySelectorAll('.customize')[0].children[0].width;
                document.querySelector('.customize img').removeAttribute('width');
                document.querySelector('.customize img').removeAttribute('height');
                document.querySelector('.customize img').setAttribute('width', '100%');
                const customizeNewImgWidth = document.querySelectorAll('.customize')[0].children[0].width;
                const percentage = customizeNewImgWidth / customizeOldImgWidth;
                const area = document.querySelectorAll('.customize area');
                for (let i = 0; i < area.length; i++) {
                    const acd = area[i].coords.split(',');
                    const aaa = [];
                    let bbb = '';
                    for (let j = 0; j < acd.length; j++) {
                        aaa.push(acd[j] * percentage);
                    }
                    bbb = aaa.join(',');
                    area[i].setAttribute('coords', bbb);
                }
            }
        },
        /* 大轮播图点击事件 */
        goactdetail(item) {
            const ths = this;
            if (item.pathType === 1) {
                window.location.href = item.path;
            } else if (item.pathType === 2) {
                if (item.linkAddress === 1) {
                    const ths = this;
                    ths.$doRequest({
                        url: '/activity/queryActivityById',
                        params: {
                            id: item.linkId
                        },
                        brfore: function () {
                            ths.loading = toastLoading();
                        },
                        complete: function () {

                        }
                    },
                    function (data) {
                        ths.ESVStorage.putSavedValue('activityDetails', data.result);
                        ths.esvOpenPage('OPFullActivitys');
                    }
                    );
                } else if (item.linkAddress === 2) {
                    ths.ESVStorage.putSavedValue('goodsId', item.linkId);
                    ths.esvOpenPage({
                        name: 'OPGoodsdetail'
                    });
                } else if (item.linkAddress === 4) {
                    ths.ESVStorage.putSavedValue('id', item.linkId);
                    ths.esvOpenPage({
                        name: 'OPGoodlist',
                        params: {
                            id: item.adMemo
                        }
                    });
                }
            }
        },
        // 查询手机号
        getMerchantInfo() {
            const ths = this;
            const params = {

            };
            return new Promise((resolve, reject) => {
                ths.$doRequest({
                    url: '/merchant/getMerchantInfo',
                    params: params,
                    before: function () {

                    // ths.loading = toastLoading();
                    },
                    complete: function () {
                    // clearToastLoading(ths.loading);
                    // afterFn && afterFn();
                    }
                },
                (data) => {
                    ths.iphoneNumber = data.result.merchantPhone;
                    ths.wechatTitle = data.result.wechantTitle;
                    document.title = ths.wechatTitle;
                    resolve(data);
                },
                (data) => {
                    reject(data);
                }
                    // function (data) {
                    //
                    // }
                );
            });
        },
        /* 热门推荐到商品详情 */
        godetail: function (item) {
            const ths = this;
            ths.ESVStorage.putSavedValue('goodsId', item.productId);
            ths.esvOpenPage({
                name: 'OPGoodsdetail',
                params: {
                    goodsId: item.productId
                }
            });
        },
        onClickLeft() {
            this.$toast.success('左按钮被点击');
        },
        onClickRight() {
            this.$toast.fail('右按钮被点击');
        },
        menuClicked(item) {
            const ths = this;
            if (item.pathType === 2) {
                ths.ESVStorage.putSavedValue('id', item.adMemo);
                ths.esvOpenPage({
                    name: 'COGoodlist',
                    params: {
                        id: item.adMemo
                    }
                });
            } else if (item.pathType === 1) {
                window.location.href = item.path;
            }
        },
        getPramVal(name) {
            const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
            const str = window.location.href.indexOf('?') === -1 ? '' : window.location.href.slice(window.location.href.indexOf('?'), window.location.href.length);
            const r = str.substr(1).match(reg);
            if (r != null) {
                return decodeURI(r[2]);
            }
            return null;
        },
        // 点击拨打客服电话
        callFn() {
            this.callshow = true;
        },
        closeCall() {
            this.callshow = false;
        }
    },
    destroyed() {
        clearInterval(this.timer);
        if (!this.loading) return;
        clearToastLoading(this.loading);
    }
};
</script>

<style lang="scss" scoped>
@import '../assets/styles/common/homenew.scss';

#page_Container {
    position: relative;
    overflow: initial;
}

.call {
    width: 44px;
    height: 44px;
    text-align: center;
    border-radius: 50%;
    line-height: 13px;
    background: rgba(255, 255, 255, 0.50);
    border: 1px solid #E3E2E2;
    position: fixed;
    right: 15px;
    bottom: 200px;

    img {
        width: 15px;
        height: 15px;
        margin-top: 5px;
    }

    .img {
        display: inline-block;
    }

    .spanText {
        display: inline-block;
    }
}

.classBottom {
    padding: 0 12px;
}

.vanSwipe {
    background: #fff;
}

.bcf {
    background-color: #fff;
}

.newSwiper {
    // background: #fff;
    margin-bottom: 4px;
    padding: 12px 12px 7px 12px;

    .commonCol {
        padding: 0 2.5px !important;
        height: 110px;
        margin-bottom: 5px;

        img {
            width: 100%;
            height: 100%;
        }
    }
}

// 首页功能
.home-menu-zone {
    border-bottom: 1px solid #eee;
}

.lunbo {
    position: relative;
}

.recommendNew {
    margin-bottom: 4px;

    .recommendContent {
        padding: 10px;
        background: #fff;

        // margin-top: 4px;
        .recommendTop {
            width: 100%;
            position: relative; // 使用相对定位
            height: 0; // 高度设置为0，使用padding来设置高度
            overflow: hidden;
            padding-bottom: calc(100% / 3);
            margin-bottom: 12px;

            img {
                position: absolute; // 使用绝对定位
                width: 100%; // 宽高为容器的宽高
                height: 100%;
                top: 0;
                left: 0
            }
        }

        .recommendBottom {
            ul {
                display: flex;
                justify-content: space-between;

                li {
                    flex: 1;
                    background: #fff;

                    .recommendImg {
                        position: relative;
                        width: 100%;
                        height: 0;
                        padding-top: 100%;
                        // text-align: center;
                        margin: 0 auto 10px;

                        img {
                            position: absolute;
                            left: 0;
                            top: 0;
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .recommendDescribe {
                        height: 40px;
                        line-height: 20px;
                        color: #414141;
                        font-size: 12px;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }

                    .goodDescribe {
                        font-size: 12px;
                        display: flex;
                        justify-content: space-between;

                        .describeLeft {
                            font-size: 12px;
                            // font-weight: 700;
                            color: #EE2E3A;
                        }

                        .describeRight {
                            color: #999999;
                        }
                    }
                }

                li:first-child {
                    margin-right: 10px;
                }
            }
        }
    }
}

.goodIntegral {
    height: 24px;
}

.bottomText {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #CCCCCC;
    text-align: center;
    padding: 12px 15px;
    font-size: 10px;

    .copyright {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        a {
            color: inherit;
        }
    }
}
.home-header {
    padding: 12px;
    .company-wrapper {
        display: flex;
        align-items: center;
        background: transparent;

        .companyName {
            color: #000;
            font-size: 12px;
            margin: 0 5px;
        }

        .location_icon {
            width: 10px;
        }
    }
}

/**向下的三角**/
.sanjiao_down {
    margin-top: 3px;
    width: 0;
    height: 0;
    overflow: hidden;
    font-size: 0;
    /*是因为, 虽然宽高度为0, 但在IE6下会具有默认的 */
    line-height: 0;
    /* 字体大小和行高, 导致盒子呈现被撑开的长矩形 */
    border-width: 4px;
    border-style: solid dashed dashed dashed;
    /*IE6下, 设置余下三条边的border-style为dashed,即可达到透明的效果*/
    border-color: #000 transparent transparent transparent;
}
</style>
